import { render, staticRenderFns } from "./PositionsRequirementSummary.vue?vue&type=template&id=686dca96"
import script from "./PositionsRequirementSummary.vue?vue&type=script&lang=ts"
export * from "./PositionsRequirementSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports